const initialState = {
	isLoading: false
};

export default (state = initialState, action) => {
	switch (action.type) {
		// Get reviewer (Admin)
		case "REVIEWER_ADMIN_IS_LOADING":
			return {
				...state,
				isLoading: 1
			};
		case "REVIEWER_ADMIN_HAS_ERROR":
			return {
				...state,
				isLoading: 0,
				error: action.error
			};
		case "REVIEWER_ADMIN_SUCCESS":
			return {
				...state,
				reviewer: action.data.data,
				isLoading: 0
			};

		// Get reviewer (user)
		case "REVIEWER_IS_LOADING":
			return {
				...state,
				isLoading: 1,
				error: null
			};
		case "REVIEWER_HAS_ERROR":
			return {
				...state,
				isLoading: 0,
				error: action.error
			};
		case "REVIEWER_SUCCESS":
			return {
				...state,
				isLoading: 0
			};

		// Generate
		case "PASSWORD_GENERATE_LOADING":
			return {
				...state,
				passwordGenerateLoading: true,
				passwordGenerateErrors: "",
				passwordGenerateSuccess: ""
			};
		case "PASSWORD_GENERATE_ERROR":
			return {
				...state,
				passwordGenerateLoading: false,
				passwordGenerateErrors: action.err
			};
		case "PASSWORD_GENERATE_SUCCESS":
			return {
				...state,
				passwordGenerateLoading: false,
				passwordGenerateErrors: "",
				passwordGenerateSuccess: action.message
			};
		case "PASSWORD_GENERATE_CLEAR_STATUS":
			return {
				...state,
				passwordGenerateErrors: "",
				passwordGenerateSuccess: ""
			};

		// Personal fields update (Admin only)
		case "UPDATE_PERSONAL_FIELDS_LOADING":
			return {
				...state,
				personalFieldsLoading: true,
				personalFieldsErrors: "",
				personalFieldsSuccess: ""
			};
		case "UPDATE_PERSONAL_FIELDS_ERROR":
			return {
				...state,
				personalFieldsLoading: false,
				personalFieldsErrors: action.err
			};
		case "UPDATE_PERSONAL_FIELDS_SUCCESS":
			return {
				...state,
				personalFieldsLoading: false,
				personalFieldsErrors: "",
				personalFieldsSuccess: action.message
			};
		case "UPDATE_PERSONAL_FIELDS_CLEAR_STATUS":
			return {
				...state,
				personalFieldsSuccess: ""
			};

		// Profile image update
		case "UPDATE_REVIEWER_IMAGE_LOADING":
			return {
				...state,
				reviewerImageUploadInProgress: true,
				reviewerImageUploadErrors: "",
				reviewerImageUploadSuccess: ""
			};
		case "UPDATE_REVIEWER_IMAGE_ERROR":
			return {
				...state,
				reviewerImageUploadInProgress: false,
				reviewerImageUploadErrors: action.err
			};
		case "UPDATE_REVIEWER_IMAGE_SUCCESS":
			return {
				...state,
				reviewerImageUploadInProgress: false,
				reviewerImageUploadErrors: "",
				reviewerImageUploadSuccess: action.message
			};
		case "UPDATE_REVIEWER_IMAGE_CLEAR_STATUS":
			return {
				...state,
				reviewerImageUploadErrors: "",
				reviewerImageUploadSuccess: ""
			};

		// Get reviewer options
		case "REVIEWER_OPTIONS_IS_LOADING":
			return {
				...state,
				reviewerOptionsLoading: 1,
				reviewerOptionsError: "",
				reviewerOptions: []
			};
		case "REVIEWER_OPTIONS_HAS_ERROR":
			return {
				...state,
				reviewerOptionsLoading: 0,
				reviewerOptionsError: action.error
			};
		case "REVIEWER_OPTIONS_SUCCESS":
			return {
				...state,
				reviewerOptionsLoading: 0,
				reviewerOptions: action.options
			};

		// Get reviewer active reviews
		case "REVIEWER_ACTIVE_REVIEWS_IS_LOADING":
			return {
				...state,
				reviewerActiveReviewsLoading: 1,
				reviewerActiveReviewsError: "",
				reviewerActiveReviews: []
			};
		case "REVIEWER_ACTIVE_REVIEWS_HAS_ERROR":
			return {
				...state,
				reviewerActiveReviewsLoading: 0,
				reviewerActiveReviewsError: action.error
			};
		case "REVIEWER_ACTIVE_REVIEWS_SUCCESS":
			return {
				...state,
				reviewerActiveReviewsLoading: 0,
				reviewerActiveReviews: action.data.data
			};
		case "SAVE_REVIEWER":
			return {
				...state,
				...action.data
			};

		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/store/reducers/reviewers.js